<template>
  <div class="page">
    <div class="layout">
      <TheHeader></TheHeader>
      <div class="main">
        <div class="aside">
          <TheHot @click="onHotClick"></TheHot>
          <TheSessionHistory :list="sessionHistory"
                             @openNewSession="onOpenNewSession"
                             @click="onHistoryClick"
                             @clearClick="onClearClick"></TheSessionHistory>
        </div>
        <div class="chat">
          <div class="chat-wrapper">
            <div class="chat-wrap" id="chat-wrap" ref="chatWrap">
              <!-- 对话 -->
              <div :class="[
              'chat-item',
              { other: message.type == ANSWER },
              { self: message.type == QUESTION },
            ]" v-for="message in messageList" :key="message.id" :id="`m-${message.id}`">
                <template v-if="message.type == ANSWER">
                  <div class="avatar">
                    <img src="@/assets/img/robothead.png" alt="" />
                    <div class="talk">{{ message.title }}</div>
                  </div>
                  <div class="message">
                    <div class="text">
                      <div class="wrap">
                        <i class="el-icon-loading" v-if="message.status === ChatStatus.Pending"></i>
                        <vue-markdown id="currentContent" v-if="false" :source="message.content"  :anchor-attributes="anchorAttrs"></vue-markdown>
                        <the-markdown  id="currentContent"
                                       v-if="message.status !== ChatStatus.Pending"
                                       :source="message.content"
                                       :think="message.think"
                                       :anchor-attributes="anchorAttrs">
                        </the-markdown>
                        <div v-if="message.answerType" class="icon-buttons">
                          <el-button @click="handleCopy(message.content)" title="复制"  style="border: none;padding: 0 5px;">
                            <img src="@/assets/img/copy.svg" alt="复制图标" width="20" height="20"  />
                          </el-button>
                          <el-button @click="handleLike" title="喜欢" style="border: none;padding: 0 5px;">
                            <img :src="likeImage" alt="喜欢图标" width="20" height="20" />
                          </el-button>
                          <el-button @click="handleDislike" title="不喜欢" style="border: none;padding: 0 5px;">
                            <img :src="dislikeImage" alt="不喜欢图标" width="20" height="20" />
                          </el-button>
                        </div>
                        <div v-if="message.status === ChatStatus.Finished && message.answerType && message.eaUrl && message.eaUrl.length > 0" class="finished-tool">
                          <el-button size="small" type="primary" @click="onShowQrCode(message)">点击扫码</el-button>
                        </div>
                        <div v-if="message.status === ChatStatus.Finished && message.answerType && message.matched_button && message.matched_button.length > 0" class="buttonContainer">
                          <el-button v-for="(item,index) in buttons" :key="index" size="small" type="primary" @click="buttonHandle(message.content,item)">{{item}}</el-button>
                        </div>
                        <div v-if="message.status === ChatStatus.Finished && message.choiceList" class="related-matters">
                          <el-popover
                            placement="top-start"
                            title=""
                            ref="popover"
                            :visible-arrow="false"
                            width="720"
                            trigger="hover"
                            :disabled="message.choiceList.length === 0"
                            :append-to-body="false"

                            >
                            <div style="width: 100%">
                              <el-table
                                :data="message.choiceList"
                                style="width: 100%">
                                <el-table-column
                                  label="事项名称"
                                 >
                                  <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row }}</span>
                                  </template>
                                </el-table-column>
                                <el-table-column label="操作"  width="80">
                                  <template slot-scope="scope">
                                    <el-link
                                      size="mini"
                                      type="primary"
                                      @click="handleChoiceItem( scope.row)">查看</el-link>
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                            <el-button slot="reference" size="small" type="primary" @click="onGetMoreInfo(message)">相关推荐</el-button>
                          </el-popover>
                        </div>

                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="message">
                    <div class="text">
                      <div class="wrap" v-html="message.content"></div>
                    </div>
                  </div>
                  <div class="avatar">
                    <img src="@/assets/img/userAvatar.png" alt="" />
                  </div>
                </template>
              </div>
            </div>

            <div class="stop-answer" v-show="currentAnswer && currentAnswer.message && currentAnswer.message.status === ChatStatus.Answering && currentAnswer.message.taskId">
              <el-button class="btn-stop-answer" icon="el-icon-video-pause" @click="onStopChatMessage">停止回答</el-button>
            </div>
          </div>
          <div class="input-wrap">
            <TheInput @confirm="submitInput"></TheInput>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="二维码扫描"
      :visible.sync="qrCodeDialogVisible"
      width="30%"
      >
      <img :src="qrcode" alt="" class="qrcode-img"/>

    </el-dialog>
  </div>
</template>

<script>
import { fetchEventSource } from '@microsoft/fetch-event-source'
import _ from 'lodash'
import VueMarkdown from 'vue-markdown';
import QRCode from 'qrcode'
import {ApiUrl, ApiToken, reasoningModel, WelcomeText, WelcomeTitle} from "@config/sys.config";
import {chatApi} from "@/api/chat-api";
import ScrollListener from '@/util/ScrollListener'

const ANSWER = "answer";
const QUESTION = "question";
const ChatStatus = {
  Pending: 'Pending',
  Answering: 'Answering',
  Finished: 'Finished',
  Stop: 'Stop',
  Fail: 'Fail'
}

export default {
  components: {
    TheHeader: () => import("@comp/TheHeader.vue"),
    TheHot: () => import("@comp/TheHot.vue"),
    // TheHistory: () => import("@comp/TheHistory.vue"),
    TheInput: () => import("@comp/TheInput.vue"),
    TheMarkdown: () => import("@comp/TheMarkdown.vue"),
    TheSessionHistory: ()=> import("@comp/TheSessionHistory.vue"),
    VueMarkdown
  },
  data() {
    return {
      ChatStatus,
      isLiked: false,
      likeImage: require('@/assets/img/thumb-up-line.svg'),
      likedImage: require('@/assets/img/thumb-up-fill.svg'),
      disisLiked:false,
      dislikeImage: require('@/assets/img/thumb-down-line.svg'),
      dislikedImage: require('@/assets/img/thumb-down-fill.svg'),
      inputMessage: "",
      messageList: [],
      ANSWER: ANSWER,
      QUESTION: QUESTION,
      inputPopoverShow: false,
      inputPopoverTimeoutHandler: null,
      buttons:[],
      anchorAttrs: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow'
      },
      questionMessage: '',
      conversationMess: [],// 存储 AI和用户 会话消息

      searchHistory: [],
      tempInputs: {
        "ea_slot": "",
        "ea_info": "",
        "ea_url": "[]",
        "ea_qr_code": "[]",
        "ea_slot_record": 0,
        "history": "",
        "choice_type": "0",
        "choice_list": "",
        "current_preferred_pool": "[]",
        "current_ea_pool": "[]",
        "in_ea_mark":"0",
        "navi_map": "",
      },
      qrCodeDialogVisible: false,
      qrcode: '',
      userId: 'abc-123',

      showVideoInputing: true,

      sessionHistory: [
       /* {
          id: '',
          chatMessages: [],
          chatTempInputs: {},
          timestamp: ''
        }*/
      ],
      currentSessionId: '',

      answerAutoScrollTimer: '',
      scrollListener: '',
      hasUserScrollInAnswering: false,
      conversationId: ''
    };
  },
  computed: {
    currentAnswer () {
       const index = this.messageList.findLastIndex(item => item.type === ANSWER);
       return {
         index: index,
         message: this.messageList[index]
       };
    }
  },
  methods: {
    onShowQrCode (message) {
      let text = message.eaUrl[0]
      QRCode.toDataURL(text, {width: 192, margin: 1}).then(res => {
        this.qrcode = res;
        this.qrCodeDialogVisible = true
      })
    },
    handleLike() {
      this.isLiked = !this.isLiked;
      this.likeImage = this.isLiked ? this.likedImage : require('@/assets/img/thumb-up-line.svg')
    },
    handleDislike() {
      this.disisLiked = !this.disisLiked;
      this.dislikeImage = this.disisLiked ? this.dislikedImage : require('@/assets/img/thumb-down-line.svg')
    },
    handleCopy(content) {
      var _this = this;
      try {
        navigator.clipboard.writeText(content);
        _this.$message.success('文本复制成功')
      } catch (error) {
        console.error('文本复制失败:', error);
      }
    },
    onStopChatMessage() {
      var _this = this;
      let params = {
        user: this.userId
      }
      chatApi.stopChat(this.currentAnswer.message.taskId, params)
        .then(ret => {
          if(ret.result === 'success') {
            const message = this.messageList[this.currentAnswer.index];
            message.status = ChatStatus.Stop
            this.updateMessageInConversation(message)
            _this.$message.success('停止回答成功')
          }
        }).catch(error=> {
          console.error(error)
        this.$message.error('停止回答失败')
      })
    },
    onGetMoreInfo() {
      this.submitInput('相关推荐', false)
    },
    handleChoiceItem (row) {
      this.submitInput(row, false)
    },
    onHotClick(item) {
      this.submitInput(item.text)
    },
    resetTempInputs(tempInputs) {
      if(!tempInputs) {
        this.tempInputs = {
          "ea_slot": "",
          "ea_info": "",
          "ea_url": "[]",
          "ea_qr_code": "[]",
          "ea_slot_record": 0,
          "history": "",
          "choice_type": "0",
          "choice_list": "",
          "current_preferred_pool": "[]",
          "current_ea_pool": "[]",
          "in_ea_mark":"0",
        }
      }else{
        this.tempInputs = tempInputs
      }
    },
    onOpenNewSession() {
      if(!this.currentSessionId) {
        return ;
      }
      this.currentSessionId = '';
      this.conversationId = '';
      this.messageList = [];
      this.sendWelcomeText();
      this.resetTempInputs();
    },
    onHistoryClick(item) {
      // 展示会话
      console.log(item)
      if(this.currentSessionId === item.id) {
        return ;
      }
      // 回显之前会话内容
      this.currentSessionId = item.id
      this.messageList = [].concat(item.chatMessages)
      this.resetTempInputs(item.chatTempInputs)
      this.scrollToBottom(item.chatMessages[item.chatMessages.length - 1])
    },
    onClearClick() {
      this.sessionHistory = [];
      localStorage.removeItem("SessionHistory")
      this.onOpenNewSession();
    },

    getUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    // 生成消息
    messageCreator(type, content = '', title, status = ChatStatus.Pending, reasoningModel = false) {
      return {
        id: this.getUUID(),
        time: new Date().getTime(),
        title: title,
        type: type,
        content: `${content}`,
        think: '',
        inThink: reasoningModel,
        reasoningModel: reasoningModel,
        status: status,
        taskId: ''
      }
    },
    addMessage2Conversation(message) {
      this.messageList.push(message);
      this.inputMessage = "";
      this.scrollToBottom(message)
    },
    scrollToBottom (message) {

      this.scrollListener.checkUserScroll((isUserScrolling) => {
        console.log('用户滚动' + isUserScrolling)
        this.hasUserScrollInAnswering = isUserScrolling;
        if(isUserScrolling) {
          clearTimeout(this.answerAutoScrollTimer)
        }
      });

      if(!this.hasUserScrollInAnswering) {
        this.answerAutoScrollTimer = setTimeout(() => {
          let messageDom = document.querySelector(`#m-${message.id}`);
          messageDom.scrollIntoView({ behavior: "smooth", block: "end" });
        }, 10);
      }

    },
    updateMessageInConversation(message) {
      const index = _.findIndex(this.messageList, ['id', message.id])
      this.messageList[index].content = message.content
      this.messageList[index].title = message.title

      for(var key in message) {
        if(['title', 'content'].indexOf(key) === -1) {
          this.$set(this.messageList[index], key, message[key])
        }
      }
      this.updateSearchHistory(message);
      this.scrollToBottom(message)
    },
    buttonHandle(content,message){
      console.log(content)
      content = this.getTextAfterSecondThinkTag(content)
      console.log(content)
      var arr = "";
      var message1 = message + "**";
      const startIndex = content.indexOf(message1);
      if (startIndex === -1) {
        arr = "";
      }
      // 从 message 首次出现的位置之后开始查找 **
      const endIndex = content.indexOf("**", startIndex + message1.length);
      if (endIndex === -1) {
        arr =  "";
      }else if(content.slice(startIndex, endIndex).length > 0){
        arr =  "**"+content.slice(startIndex, endIndex);
      }
      if(arr){
        this.submitInputWithAnswer(message,arr)
      }else {
        this.submitInput(message)
      }
    },
    getTextAfterSecondThinkTag(text) {
      const lastIndex = text.lastIndexOf('</think>');
      if (lastIndex === -1) {
        // 如果没有找到 </think> 标签，返回原字符串
        return text;
      }
      // 截取最后一个 </think> 标签之后的数据
      return text.slice(lastIndex + 8);
    },
    // 输入框提交事件
    submitInputWithAnswer(message,answer) {
      if(!this.currentSessionId) {
        this.currentSessionId = this.getUUID()
        this.sessionHistory.push({
          id: this.currentSessionId,
          chatMessages: [].concat(this.messageList.concat()),
          chatTempInputs: this.tempInputs,
          timestamp: new Date().getTime()
        })
      }

      this.inputMessage = message
      this.questionMessage = this.inputMessage

      // 添加问的内容
      let question = this.messageCreator(QUESTION, this.inputMessage, '', ChatStatus.Finished)
      this.addMessage2Conversation(question);
      this.addSearchHistory(question);

      // 添加回答等待效果
      let emptyAnswer = this.messageCreator(ANSWER);
      this.addMessage2Conversation(emptyAnswer);
      this.addSearchHistory(emptyAnswer);

      // 请求服务器
      const id = emptyAnswer.id
      emptyAnswer.status = ChatStatus.Finished;
      emptyAnswer.content = answer;
      emptyAnswer.id = id;
      emptyAnswer.title = '为您找到这些'
      this.updateMessageInConversation(emptyAnswer)
    },
    submitInput(message) {
      this.hasUserScrollInAnswering = false;

      if(!this.currentSessionId) {
        this.currentSessionId = this.getUUID()
        this.sessionHistory.push({
          id: this.currentSessionId,
          chatMessages: [].concat(this.messageList.concat()),
          chatTempInputs: this.tempInputs,
          timestamp: new Date().getTime()
        })
      }

      this.inputMessage = message
      this.questionMessage = this.inputMessage

      // 添加问的内容
      let question = this.messageCreator(QUESTION, this.inputMessage, '', ChatStatus.Finished)
      this.addMessage2Conversation(question);
      this.addSearchHistory(question);

      // 添加回答等待效果
      // 判断是否是思考模型
      let emptyAnswer
      if(reasoningModel) {
        emptyAnswer = this.messageCreator(ANSWER, '', '', ChatStatus.Pending, true)
      } else {
        emptyAnswer = this.messageCreator(ANSWER);
      }
      this.addMessage2Conversation(emptyAnswer);
      this.addSearchHistory(emptyAnswer);

      // 请求服务器
      this.searchAnswer(emptyAnswer);
    },

    addSearchHistory(message) {
      const index = _.findIndex(this.sessionHistory, ['id', this.currentSessionId])
      const searchHistory = this.sessionHistory[index].chatMessages
      searchHistory.push(message);
      localStorage.setItem("SessionHistory", JSON.stringify(this.sessionHistory))
    },
    updateSearchHistory(message) {
      const sessionIndex = _.findIndex(this.sessionHistory, ['id', this.currentSessionId])
      this.sessionHistory[sessionIndex].chatTempInputs = this.tempInputs
      const searchHistory = this.sessionHistory[sessionIndex].chatMessages
      const messageIndex = _.findIndex(searchHistory, ['id', message.id])
      searchHistory[messageIndex] = message
      localStorage.setItem("SessionHistory", JSON.stringify(this.sessionHistory))
    },
    removeConversationMessById (id) { // 根据id移除会话
      _.remove(this.messageList, ['id', id])
    },

    searchAnswer(message) {
      var that = this;
      var abortController = new AbortController()
      message.status = ChatStatus.Pending;
      const id = message.id
      fetchEventSource(ApiUrl + "/chat-messages", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + ApiToken // 鉴权
        },
        body: JSON.stringify({
          "inputs": this.tempInputs,
          "query": this.questionMessage,
          "response_mode": "streaming",
          "conversation_id": this.conversationId,
          "user": this.userId,
        }),
        openWhenHidden: true, // 页面文档被隐藏时会关闭sse链接并在显示时重连 true无论隐藏与否都不关闭
        signal: abortController.signal, // AbortSignal
        onmessage: async (ev) => { // 接收到消息之后填充消息数据
          const data = JSON.parse(ev.data)

          const event = data.event
          if(event === 'message') {
            console.log(data)
            // data.answer = data.answer.replace(/\n/g, "</br>");
            if(message.status === ChatStatus.Stop) return ;

            // if (data.answer.indexOf('</think>') > -1) {
            //   console.log('Finded!')
            //   const arr = data.answer.split('</think>');
            //   if (arr.length === 1) {
            //     message.content += arr[0] + '</think>'
            //   } else if (arr.length >= 2) {
            //     message.content += arr[0] + '</think>'
            //     data.answer = arr[1]
            //   }
            //   data.answer = '\n\n' + data.answer
            //   message.content = '> ' + message.content.trim()
            //   message.content = message.content.trim().replaceAll('</br>', '\n> ')
            // }
            if(message.reasoningModel) {
              if(message.inThink) {
                message.think += data.answer;
                if(message.think.indexOf('</think>') > -1) {
                  let arr = message.think.split('</think>')
                  message.think = arr[0];
                  message.inThink = false
                  message.content += arr[1]
                }
              } else {
                message.content += data.answer;
              }
            } else {
              message.content += data.answer;
            }

            message.id = id;
            message.title = '为您找到这些'
            message.taskId = data.task_id;
            message.status = ChatStatus.Answering;
            this.updateMessageInConversation(message)
          } else if (event === 'node_finished') {
            const result = data.data
            if (result.status !== 'succeeded') {
              console.error('node_finished出错了：')
              console.error(result.error)
              return
            }

            const outputs = result.outputs
            if (!outputs || !outputs.end_flag || outputs.end_flag !== 1) {
              // 未结束，不做处理
              return
            }
            this.tempInputs = outputs
            console.log('node_finished')
            console.log(data.data.outputs)
            if(data.data.outputs.matched_button){
              that.buttons=eval(data.data.outputs.matched_button);
            }
            // 完成后处理
            message.title = '为您找到这些';
            message.id = id;
            message.relevantKnowledgeList = outputs.relevantKnowledgeList || [];
            message.relevantEaList = outputs.relevantEaList || [];
            message.eaUrl =outputs.ea_url || '';
            message.matched_button =outputs.matched_button || '';
            message.answerType = outputs.answer_type || '';

            console.log('outputs.choice_list')
            console.log(outputs.choice_list)
            try {
              if(outputs.choice_list) {
                message.choiceList = JSON.parse(outputs.choice_list);
              }else {
                message.choiceList = ''
              }
            }catch(e) {
              console.error(e)
              message.choiceList = ''
            }

            message.taskId = data.task_id;
            message.status = ChatStatus.Finished;

            this.updateMessageInConversation(message)
          } else if(event === 'error') {
            // 提示错误信息
            console.log(data.message)
            message.title = '请求失败';
            message.status = ChatStatus.Fail;
            message.content = '请求失败，请重试';
            this.updateMessageInConversation(message)
          } else if(event === 'message_end') {
            // 消息结束事件，收到此事件则代表流式返回结束
            if(message.status === ChatStatus.Answering) {
              message.status = ChatStatus.Finished;
            }
            // this.conversationId = data.conversation_id;
          }

        },
        onopen: (res) => { // 打开
          if (res.status !== 200) {
            console.error('chatMessage失败：', res)
            message.title = '请求失败';
            message.status = ChatStatus.Fail;
            message.content = '很抱歉，服务器开小差了，请您稍后再试';
            this.updateMessageInConversation(message)
          }
        },
        onclose: () => { // 连接关闭
          console.log('连接关闭')
        },
        onerror: (err) => { // 失败
          abortController.abort()
          console.error('chatMessage失败：', err)
          message.title = '请求失败';
          message.status = ChatStatus.Fail;
          message.content = '很抱歉，服务器开小差了，请您稍后再试';
          this.updateMessageInConversation(message)
        }
      })

         /* this.updateMessageInConversation(emptyMessage.id, res, '为您找到这些');

          this.updateMessageInConversation(
            emptyMessage.id,
            `<p>${err}</p>
            <p>[自动回复] 当前系统繁忙，请稍后...</p>
            <p class="link">
              <a href="http://www.baidu.com" target="_blank">去网上看看</a>
            </p>`,
            '出问题了。。。'
          );*/

    },
    sendWelcomeText() {
      this.addMessage2Conversation(
        this.messageCreator(
          ANSWER,
          WelcomeText,
          WelcomeTitle,
          ChatStatus.Finished
        )
      );
    },
  },
  mounted() {
    var sessionHistory = localStorage.getItem("SessionHistory")
    if(sessionHistory) {
      this.sessionHistory = JSON.parse(sessionHistory)
    }

    this.scrollListener = new ScrollListener(this.$refs.chatWrap);

    this.sendWelcomeText()
  },
};
</script>

<style>
blockquote {
  color: #8b8b8b;
  white-space: pre-wrap;
  margin: 0;
  padding: 0 0 0 13px;
  line-height: 26px;
  position: relative;
}
</style>

<style lang="scss" scoped>
@import '~@/assets/css/_var.scss';
.buttonContainer{

  display: flex; flex-wrap: wrap; gap: 10px; /* 按钮间距 */
  margin-top:16px;
  ::v-deep{
    .el-button{
      flex: 0 0 calc(25% - 10px); box-sizing: border-box; /* 防止边框影响布局 */ /* 可选样式 */ padding: 10px; margin: 0; /* 清除默认 margin */ text-align: center; white-space: nowrap; /* 防止文字换行 */
    }
  }
}
.page {
  .layout {}
  .qrcode-img {
    display: block;
    margin: 0 auto;
  }
  .main {
    display: flex;
    height: 720px;
    width: 1200px;
    position: relative;
    background: #fff;
    border-radius: 14px;
  }

  .aside {
    padding-top: 50px;
    width: $sideWidth;
    background: rgba(246, 249, 254, 1);
  }

  .chat {
    font-size: $chatFontSize;
    background: url("~@img/chat-bg.png") no-repeat;
    background-size: auto 100%;
    background-position: 100% 100%;
    padding: 20px 0 20px 20px;

    .input-wrap {
      margin-top: 20px;
      margin-left: 20px;
    }
  }

  .chat-wrapper {
    height: $chatHeight;
    width: $chatWidth;
    position: relative;
    display: flex;
    flex-direction: column;
    .stop-answer {
      text-align: center;
      z-index: 9999;
      margin-top: 10px;
      .btn-stop-answer {
        border-radius: 10px;
      }
    }
  }

  .chat-wrap {
    height: $chatHeight;
    width: $chatWidth;
    overflow-y: auto;
    padding-right: 20px;

    .chat-item {
      width: 100%;

      &+.chat-item {
        margin-top: 14px;
      }

      .avatar {
        display: flex;
        align-items: center;
        user-select: none;

        img {
          width: 50px;
        }

        .talk {
          font-weight: bold;
          //font-size: 16px;
          user-select: none;
          margin: 0 14px;
        }
      }

      .message {
        padding: 0 20px;
        max-width: calc( 100% - #{$avatarWidth} * 2 - 40px );

        .text {
          box-shadow: 0 0 8px #e4e4e4;
          margin-top: 10px;
          border-radius: 10px;
          //position: relative;

          .wrap {
            height: 100%;
            width: 100%;
            padding: 10px 20px;
            line-height: 2;
            background: #fff;
            border-radius: 10px;
            //z-index: 10;
            //position: relative;
            border-radius: 0 10px 10px 10px;

            .finished-tool {
              text-align: right;
              margin-top: 10px;
            }

            .related-matters {
              text-align: left;
              margin-top: 10px;
              position: relative;
              ::v-deep .el-popover {
                top: auto !important;
                bottom: 30px !important;
              }
            }
          }
        }
      }

      &.self {
        display: flex;
        justify-content: flex-end;

        .text {
          .wrap {
            background: linear-gradient(90deg, rgba(38, 111, 235, 1) 0%, rgba(66, 135, 255, 1) 100%);
            color: #fff;
            border-radius: 10px 0 10px 10px;
          }
        }
      }
    }
  }

}
.icon-buttons {
  display: flex;
  gap: 10px;
  background: none;
  border: 1px solid #ccc; /* 设置边框 */
  border-radius: 20px; /* 设置圆角 */
  padding: 5px; /* 设置内边距 */
  display: inline-flex; /* 使用 inline-flex 使容器宽度自适应内容 */
  gap: 10px; /* 设置按钮之间的间距 */
}


</style>
